import React from 'react';
// import {TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { green } from '@material-ui/core/colors';

import Liste from '../Codification/Liste';
import MyDateField from '../Codification/MyDateField';
import util from '../../utils/util';

export default function ListeProductionBrique(){
    const [productions,setProductions] = React.useState([]);
    const history = useHistory();
   
    const colonnes = [
        { title: 'Date', field: 'date_operation', type:'date',
            filterComponent: props =>
            <MyDateField 
                name="date_operation"
                value={props.columnDef.tableData.filterValue||""}
                onChange={e=>{
                    props.columnDef.tableData.filterValue = e.target.value;
                    props.onFilterChanged(props.columnDef.tableData.columnOrder,e.target.value)
                }}
                errors={[]}
                label=" "
            />
        },
        { title: 'Operation', field: 'operation.date_operation' },
        { title: 'Type', field: 'type_brique.nom' },
        { title: 'Quantite', field: 'quantite',
            cellStyle:{textAlign:"right"},
            headerStyle:{textAlign:'right'},
            filtering:false,
            render:rowdata=>util.separteurMillier(rowdata.quantite)
        },
        { title: 'Description', field: 'description' },
    ];
    return (
            <Liste table='production-brique' 
                values={productions} 
                setValues={setProductions}
                colonnes={colonnes}
                editable={{
                    onRowUpdate:null,
                    onRowAdd:null
                }}
                actions={[
                    {
                        icon: 'add_circle',
                        iconProps:{style:{fontSize:50,color:green[500]}},
                        tooltip: 'Nouvelle production',
                        isFreeAction: true,
                        onClick: (event, rowData) => history.push("/production-briques")
                    },
                    {
                        icon: 'visibility',
                        iconProps:{color:'primary'},
                        tooltip: 'Afficher production',
                        onClick: (event, rowData) => history.push(`/production-briques/view/${rowData.id}`)
                    },
                    {
                        icon: 'edit',
                        tooltip: 'Modifier production',
                        onClick: (event, rowData) => history.push(`/production-briques/${rowData.id}`)
                    },
                ]}

            />
    )
};

